import { render, staticRenderFns } from "./ExampleUploadFile.vue?vue&type=template&id=3f4930c6&scoped=true&"
import script from "./ExampleUploadFile.vue?vue&type=script&lang=js&"
export * from "./ExampleUploadFile.vue?vue&type=script&lang=js&"
import style0 from "./ExampleUploadFile.vue?vue&type=style&index=0&id=3f4930c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4930c6",
  null
  
)

export default component.exports